import React from "react";
import AccessoriesInner from "../../categoryinnerpage";
import SEO from "../../seo";

export default function MattressProtectorsPage() {
  const categoryName = "Mattress Protectors";
  const products = [
    {
      img: "https://eclipsemattress.in/wp-content/uploads/2019/12/Mattress-Protector.jpg",
      name: "Mattress Protector",
      description: "",
    },
  ];

  const categoryDescription =
    "Explore premium mattress protectors that provide a healthy and clean sleeping environment and improve mattress durability. Each soft and quilted mattress protector is designed to be waterproof, hypoallergenic, breathable and stainproof. All mattress protectors are uniquely constructed to deliver the best in utility, safety and comfort.";
  return (
    <div>
      <SEO
        title="Mattress Protectors | Accessories | Eclipse International"
        description="Shop mattress protectors from Eclipse International and keep your mattresses free of spillage, staining, allergens and dust mites."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-main.jpg"
      />
      <AccessoriesInner
        products={products}
        categoryName={categoryName}
        categoryDescription={categoryDescription}
      />
    </div>
  );
}
